export default __webpack_public_path__ + "static/media/beetle-shape.25dcd4fa.svg";